import { outLogin } from "@/services/api/api";
import type { Settings as LayoutSettings } from "@ant-design/pro-components";
import "@ant-design/v5-patch-for-react-19";
import type { RequestConfig, RunTimeLayoutConfig } from "@umijs/max";
import { history } from "@umijs/max";
import { Button, Modal } from "antd";
import { useState } from "react";
import defaultSettings from "../config/defaultSettings";
import logoIcon from "./assets/images/logoHome.png";
import { authService } from "./pages/utils/tools";
import { errorConfig } from "./requestErrorConfig";

const isDev = process.env.NODE_ENV === "development";
const loginPath = "/user/login";
// const { initialState, setInitialState } = useModel('@@initialState');

export async function getInitialState(id: number): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  fetchUserInfo?: (id: number) => Promise<API.CurrentUser | undefined>;
}> {
  return {
    // fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

const loginOut = async () => {
  const { search, pathname } = window.location;
  const urlParams = new URL(window.location.href).searchParams;
  const searchParams = new URLSearchParams({
    redirect: pathname + search,
  });
  const redirect = urlParams.get("redirect");
  // Note: There may be security issues, please note
  if (window.location.pathname !== "/user/login" && !redirect) {
    history.replace({
      pathname: "/user/login",
      search: searchParams.toString(),
    });
  }
  await outLogin();
  authService.logout();
};
export const layout: RunTimeLayoutConfig = ({
  initialState,
  setInitialState,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  return {
    avatarProps: {
      render: (_, avatarChildren) => {
        return (
          <>
            <Button
              style={{
                width: 119,
                height: 48,
                fontSize: 24,
                background: "#FF4C75",
                borderRadius: 24,
                marginRight: 40,
                fontFamily: "Rubik",
              }}
              color="danger"
              variant="solid"
              onClick={() => setModalVisible(true)}
            >
              Logout
            </Button>
            <Modal
              title="Logout"
              open={modalVisible}
              onOk={() => loginOut()}
              onCancel={() => setModalVisible(false)}
              okText="Logout"
              cancelText="Cancel"
            >
              <p>Are you sure you want to log out of your current account?</p>
            </Modal>
          </>
        );
      },
    },
    waterMarkProps: {
      content: initialState?.currentUser?.name,
    },
    onPageChange: () => {
      const { location } = history;
      // If you are not logged in, redirect to login
      const publicPaths = [loginPath, "/invite"];
      if (!authService.getToken() && !publicPaths.includes(location.pathname)) {
        history.push(loginPath);
      }
    },
    menu: {
      fontFamily: '"Rubik", sans-serif',
      className: "my-custom-menu",
    },
    menuHeaderRender: (logo, title) => {
      return (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <img src={logoIcon} alt="logo" />
        </div>
      );
    },
    // Custom 403 page
    unAccessible: <div>Not Found</div>,
    ...initialState?.settings,
  };
};

export const request: RequestConfig = {
  baseURL: process.env.REACT_APP_API_BASE_URL,
  ...errorConfig,
};
